var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgCheckMark = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 19,
  height: 14,
  fill: "none",
  viewBox: "0 0 19 14"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#0072CE",
  d: "m.308 6.672 2.12-1.963 4.95 4.581-2.12 1.964z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#0072CE",
  d: "M5.257 11.254 16.571.782l2.121 1.964L7.38 13.217z"
})));
export { SvgCheckMark as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTkiIGhlaWdodD0iMTQiIHZpZXdCb3g9IjAgMCAxOSAxNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTAuMzA3NjE3IDYuNjcyMTZMMi40Mjg5NCA0LjcwODczTDcuMzc4NjggOS4yOTAwNkw1LjI1NzM2IDExLjI1MzVMMC4zMDc2MTcgNi42NzIxNloiIGZpbGw9IiMwMDcyQ0UiLz4KPHBhdGggZD0iTTUuMjU3MzYgMTEuMjUzNUwxNi41NzEgMC43ODIyMjdMMTguNjkyMyAyLjc0NTY1TDcuMzc4NTcgMTMuMjE3M0w1LjI1NzM2IDExLjI1MzVaIiBmaWxsPSIjMDA3MkNFIi8+Cjwvc3ZnPgo=";